import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Send } from 'lucide-react';
import CommsDialog from '../components/CommsDialog';

// Admin → Send Message: pick any contacts/members (lists, classes, individuals, typed emails) and any message
// format on the system (built-in templates, saved email templates, Articles) or free text; email, SMS or letter.
export default function MessageTab() {
  const navigate = useNavigate();
  return (
    <div className="space-y-3" data-testid="message-tab">
      <div>
        <h2 className="font-title text-xl flex items-center gap-2" style={{ color: 'var(--maroon)' }}><Send size={20} /> Send a message</h2>
        <p className="text-sm" style={{ color: 'var(--olive)' }}>Choose who receives it — a list, a member class, individual members or contacts, or typed email addresses — then pick a format: a built-in template, one of your email templates, an Article, or free text. Preview per recipient before sending.</p>
      </div>
      <CommsDialog inline onClose={() => navigate('/admin')} />
    </div>
  );
}
